<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">
      Dissociate User
    </h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onClose()"
      title="Close"
    ></i>
  </div>

  <div class="modal-body">
    <p>
      Dissociating the user will revoke its access from the deployment. Do you
      want to proceed?
    </p>
  </div>

  <div *ngIf="isUserDetach && isVdi == false" class="px-3 mb-2">
    <mat-checkbox
      class="deleteFromClusterCheckbox"
      [(ngModel)]="deleteFromCluster"
      (change)="deleteFromClusterChange($event)"
    >
      Do you want to delete user from deployment?
    </mat-checkbox>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      No
    </button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">
      Yes
    </button>
  </div>
</div>
